module.exports = __webpack_public_path__ + "img/index-section6-friend4_a.f78605bf.svg";